module.exports = __webpack_public_path__ + "fonts/5c50b56717c892d1a06d3ff6135d4333.svg";